import { useQuery } from '@tanstack/react-query';
import { getDepartmentSectionById } from '../apis/department';

interface UseDepartmentSectionsByIdParams {
  sectionId: string;
  departmentSectionTypeId?: string;
}

export const useDepartmentSectionsByIdQuery = ({
  sectionId,
}: UseDepartmentSectionsByIdParams) => {
  return useQuery({
    queryKey: ['department-section-detail', sectionId],
    queryFn: () => getDepartmentSectionById(sectionId),
    enabled: !!sectionId,
    staleTime: 1000 * 60 * 5,
    retry: 3,
    retryDelay: 1000,
  });
};
